export default {
  general: {
    name: "Flow Simulation Game",
    yes: "Ja",
    no: "Nein",
    week: "Woche",
    add: "Hinzufügen",
    update: "Ändern",
    close: "Schließen",
    cancel: "Abbrechen",
    search: "Suchen",
    actions: "Aktionen",
    language: "Sprache",
    smallWeek: "W"
  },
  menu : {
    home : 'Home',
    games : 'Spiele',
    gameVersions : "Spielversionen",
    demandProfiles : "Nachfrageprofile",
    instructions : "Anleitungen",
    users: "Benutzer",
    params : "Tokens",
    logout : "Logout",
    profile: "Mein Konto"
  },
  fields: {
    required: "Erforderlich"
  },
  tokens: {
    token: "Token | Tokens",
    balance: "Ihr Guthaben beträgt derzeit {nbr} Token | Ihr Guthaben beträgt {nbr} Token",
    title: "Token",
    date: "Datum",
    orders: "Token-Bestellhistorie",
    number: "Anzahl Token",
    cost: "Kosten",
    bill: "Rechnung",
    status: "Status"
  },
  users: {
    firstname: "Vorname",
    lastname: "Nachname",
    login: "Login",
    role: "Rolle",
    password: "Passwort",
    lang: "Sprache",
    passwordRule: "Mindestens 8 Zeichen",
    passwordConfirmation: "Das Passwort muss identisch sein",
    confirmation: "Bestätitgung",
    listTitle: "Benutzer",
    addTitle: "Benutzer hinzufügen",
    updateTitle: "Benutzer ändern",
    deleteConfirmation: "Wollen Sie {count} Benutzer löschen? | Wollen Sie {count} Benutzer löschen?"
  },
  roles: {
    trainner: "Trainer",
    admin: "Admin",
    superAdmin: "Super Admin"
  },
  demandProfiles: {
    name: "Name",
    type: "Profiltyp",
    min: "Min",
    max: "Max",
    constant: "Konstanter Wert",
    variability: "Schwankung",
    confirmation: "Bestätigung",
    customDemandsTitle: "Individuelles Bedarfsprofil",
    importDemandsButton: "Bedarf importieren",
    importDemandsTemplateButton: "Excel-Vorlage herunterladen",
    weekNumber: "Woche Nr.",
    demands: "Bedarfsmenge",
    listTitle: "Bedarfsprofile",
    addTitle: "Bedarfsprofil hinzufügen",
    updateTitle: "Bedarfsprofil ändern",
    deleteConfirmation: "Wollen Sie wirklich {count} Bedarfsprofil löschen? | Wollen Sie wirklich {count} Bedarfsprofile löschen?",
    typeList: {
      custom: "Individuell",
      randomBetweenTwoValue: "Zufällig zwischen zwei Werten",
      constant: "Konstanter Wert"
    },
    variabilityHint: "In % (Bsp.: 20% des Bedarfs von 10 Wert zwischen 8 und 12)"
  },
 instructions: {
    name: "Name",
    addInstruction: "Anleitung(en) hinzufügen",
    listTitle: "Anleitungsliste",
    addTitle: "Anleitungsliste hinzufügen",
    updateTitle: "Anleitungsliste aktualisieren",
    deleteConfirmation: "Wollen Sie wirklich {count} Anleitungsliste löschen? | Wollen Sie wirklich {count} Anleitungslisten löschen?"
  },
  gameVersions: {
    type: "Typ",
    dd: "DD",
    standard: "Standard",
    updateLogo: "Logo ändern",
    menu: "Menü",
    params: "Parameter",
    style: "Stile",
    name: "Name",
    colors: {
      primary: "Primärfarbe",
      secondary: "Sekundärfarbe"
    },
    maxOrder: "Höchste Bestellmenge",
    skipInstructions: "Anleitung überspringen",
    timerActivated: "Täglichen Timer",
    timerCount: "Dauer des Timers",
    timerCountHint: "In Sekunden pro Schritt",
    storageCost: "Bestandskosten",
    delayCost: "Fehlmengenkosten",
    weekNbrAutoCmj: "Anzahl Wochen für automatische ADU-Berechung",
    changeBufferEveryNbrWeek: "Der Puffer kann alle x Wochen geändert werden",
    versionToDuplicate: "Zu duplizierende Spielversion",
    listTitle: "Spielversionen",
    addTitle: "Spielversion hinzufügen",
    addNew: "Neue Version",
    addFromVersion: "Aus einer bestehenden Version",
    updateTitle: "Spielversion ändern",
    deleteConfirmation: "Wollen Sie wirklich {count} Spielversion löschen? | Wollen Sie wirklich {count} Spielversionen löschen?",
    flowEquationDisplayModes: {
      title: "Azeige der Net-Flow-Gleichung",
      notDisplay: "Net-Flow-Gleichung wird nicht angezeigt",
      alreadyCalculated: "Net-Flow-Gleichung wird mit Werten angezeigt",
      show: "Werte der Net-Flow-Gleichung müssen eingegeben  werden"
    },
    ddOrderPreFilled: "Bestellmengen im DD-Modus voreintragen"
  },
  games: {
    test: "Test-Modus",
    favorites: "Favoriten",
    name: "Name",
    code: "Code",
    version: "Version",
    createdBy: "Erstellt von",
    createdAt: "Erstellungsdatum ",
    status: "Status",
    listTitle: "Spiele",
    addTitle: "Ein neues Spiel erstellen",
    deleteConfirmation: "Wollen Sie wirklich {count} Spiel löschen? | Wollen Sie wirklich {count} Spiele löschen?",
    statusList: {
      created: "Erstellt",
      open: "Offen",
      inProgress: "Im Gang",
      finished: "Beendet"
    },
    pause: "Das Spiel wurde pausiert",
    play: "Das Spiel wurde gestartet",
    stop: "Sie haben das Spiel beendet",
    start: "Das Spiel wurde gestartet",
    debriefOn: "Sie haben Zugriff auf die Auswertung",
    debriefOff: "Sie haben keinen Zugriff mehr auf die Auswertung"
  },
  inGame: {
    delete: "Das Speiel löschen und meine Token zurückerhalten",
    deleteConfirmation: "Wollen Sie das Spiel wirklich endgültig löschen?",
    setPause: "Pausieren",
    setPlay: "Spielen",
    endGame: "Spiel beenden",
    reopenGame: "Startet das Spiel erneut",
    debriefOn: "Auf die Auswertung zugreifen",
    debriefOff: "Auswertung verbergen",
    companies: {
      playerName: "Spieler",
      companies: "Firmen",
      step: "Schritt",
      assigned: "Verbunden",
      ready: "Bereit",
      code: "Code",
      steps: {
        clientOrder: "Kundenauftrag",
        clientShipment: "Kundenlieferungen",
        supplierShimpentWaiting: "Warten auf Lieferungen",
        board: "Dashboard",
        supplierShipments: "Nachschublieferungen",
        supplierOrders: "Lieferantenaufträge",
        productionBatch: "Fertigungsbeginn",
        productionShipments: "Lieferungen aus Fertigung",
        startNewWeek: "Eine neue Woche beginnen",
        inProgressProduction: "Fertigungsaufträge in Arbeit",
      }
    },
    resume: {
      resume: "Zusammenfassung",
      averageOrderQuantity: "Mittlerer Lieferantenbedarf",
      averageRequestQuantity: "Mittlerer Kundenbedarf",
      range: "Bedarfsbereich",
      otd: "Pünktliche Lieferung",
      delaysDepth: "Verspätungen in Wochen",
      averageStock: "Mittlerer Bestand",
      stockCost: "Bestandskosten",
      delayCost: "Fehlmengenkosten",
      cost: "Gesamtkosten",
	},
    red: "Rote Zone",
    yellow: "Gelbe Zone",
    green: "Grüne Zone",
    flowEquation: "Net Flow",
    stock: "Bestand",
    buffers: "Puffer",
    orders: "Aufträge",
    costs: "Kosten",
    stockRemains: "Bestand & Fehlmengen",
    shortage: "Fehlmenge",
    supplychainGraph: "Supply Chain",
    repport: "Bericht (PDF)"
  },
  companiesSettings: {
    supplyPicture: "Karte der Supply Chain",
    logo: "Logo",
    name: "Name",
    level: "Niveau",
    suppliers: "Lieferant(en)",
    clients: "Kunde(n)",
    leadTime: "Lieferzeit",
    productionLeadTime: "Fertigungsdurchlaufzeit",
    initialStock: "Anfangsbestand",
    firstOrder: "Erster Auftrag",
    firstProduction: "Erste Fertigung",
    ddOn: "DD-Modus aktiviert",
    simulatedCompany: "Von System simuliert",
    productionCompany: "Fabrik",
    assemblyMode: "Montagemodus",
    demandProfile: "Bedarfsprofile",
    confirmation: "Bestätigung",
    listTitle: "Firmen",
    addTitle: "Firma hinzufügen",
    updateTitle: "Firma aktualisieren",
    deleteConfirmation: "Wollen Sie wirklich {count} Firma löschen? | Wollen Sie wirklich {count} Firmen löschen?",
    updateLogo: "Logo aktualisieren",
    updateSupplyPicture: "Karte der Supply Chain aktualisieren"
  },
  notifications: {
    users: {
      welcome : "Willkomen ",
      sessionExpired : "Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an",
      getOneError: "Fehler beim Laden von Nutzer: ",
      getAllError: "Fehler beim Laden der Nutzer: ",
      add: "Der Nutzer wurde hinzugefügt",
      addError: "Fehler beim Erstellen des Nutzers: ",
      update: "Der Nutzer wurde geändert",
      updateError: "Fehler beim Ändern des Nutzers: ",
      delete: "Löschen erfolgreich",
      deleteError: "Fehler beim Löschen des Nutzers: "
    },
    demandProfiles: {
      getOneError: "Fehler beim Laden des Bedarfsprofils: ",
      getAllError: "Fehler beim Laden der Bedarfsprofile: ",
      add: "Bedarfsprofile hinzugefügt",
      addError: "Fehler beim Ändern des Bedarfsprofils: ",
      update: "Das Bedarfsprofil wurde geändert",
      updateError: "Fehler beim Ändern des Bedarfsprofils: ",
      delete: "Löschen erfolgreich",
      deleteError: "Fehler beim Löschen des Bedarfsprofils: "
    },
    gameVersions: {
      getOneError: "Fehler beim Laden der Spielversion: ",
      getAllError: "Fehler beim Laden der Spielversionen: ",
      add: "Spielversionen hinzugefügt",
      addError: "Fehler beim Erstellen der Spielversion: ",
      update: "Spielversion geändert",
      updateError: "Fehler beim Ändern der Spielversion: ",
      delete: "Löschen erfolgreich",
      deleteError: "Fehler beim Löschen der Spielversion: "
    },
    companiesSettings: {
      getOneError: "Fehler beim Laden des Knotens: ",
      getAllError: "Fehler beim Laden der Knoten: ",
      add: "Knoten hinzugefügt",
      addError: "Fehler beim Erstellen des Knotens: ",
      update: "Knoten geändert",
      updateError: "Fehler beim Ändern des Knotens: ",
      delete: "Löschen erfolgreich",
      deleteError: "Fehler beim Löschen des Knotens: "
    },
    games: {
      getOneError: "Fehler beim Laden des Spiels: ",
      getAllError: "Fehler beim Laden der Spiele: ",
      add: "Spiel hinzugefügt",
      addError: "Fehler beim Anlegen des Spiels: ",
      update: "Spiel geändert",
      updateDemands: "Bedarfsprofil geändert",
      updateDemandsError: "Fehler beim Ändern des Bedarfsprofils: ",
      updateError: "Fehler beim Ändern des Spiels: ",
      delete: "Löschen erfolgreich",
      deleteError: "Fehler beim Löschen des Spiels: "
    }
  },
  socketMessages: {
    playerReady : "Der folgende Knoten ist bereit: ",
    stepChange : "Der folgende Knoten geht zum nächsten Schritt: ",
    connexion : "Knoten wird verbunden: ",
    clientsShipments : "Der folgende Knoten liefert an seine Kunden: ",
    suppliersOrders : "Der folgende Knoten bestellt: ",
    productionBatch: "Der folgende Knoten beginnt die Fertigung: ",
    customerUpdate: "Knoten aktualisieren: "
  }
}